import React from 'react';
import { Select } from '~/components/Select';
import { useAdminService } from '~/services';
import { EntityTypeType } from '~/components/Admin';
import { MarketRestrictionType } from '../../RoleRow';

interface MarketRestrictionProps {
    entityType: EntityTypeType;
    entityName: number | string;
    value: MarketRestrictionType[];
    setValue: (x: MarketRestrictionType[]) => void;
}
export function MarketRestriction({
    entityType,
    entityName,
    value,
    setValue,
}: MarketRestrictionProps) {
    const { getCachedMarkets } = useAdminService();
    const [list, setList] = React.useState<
        { value: { id: number; name: string }; label: string }[]
    >([]);

    React.useEffect(() => {
        (async () => {
            const result: { id: number; name: string }[] = await getCachedMarkets();
            // exclude selected markets from the options list
            setList(
                result
                    .map((market) => ({
                        value: market,
                        label: market.name,
                    }))
                    .filter(
                        (market) =>
                            !value?.some(
                                (selectedMarket) => selectedMarket.value.id === market.value.id
                            )
                    )
            );
        })();
    }, [getCachedMarkets, value]);

    if (entityType !== 'organization') return null;
    return (
        <Select
            menuPosition="fixed"
            className="ms-3 mt-2"
            classNamePrefix="option-with-description"
            placeholder="Select Markets..."
            label={`Market Restriction ${entityName}`}
            options={list}
            isMulti
            value={value}
            onChange={setValue}
        />
    );
}
